module.exports = __webpack_public_path__ + "media/images/cplook/favicon-96x96-0abb9ff5b1229ff9d8b6686685944611.png";